import axios from "axios";

const PREFIJO = "/api/TpPrsFrm/"

export default {
    tipoPersona(){
        const dto = {
        }
        return axios.post(`${PREFIJO}VmLsTpPr`,dto);
    }
}